import get from "lodash/get";
import map from "lodash/map";
import capitalize from "lodash/capitalize";
import React from "react";
import defaults from "lodash/defaults";
import set from "@rill/set";
import ToolTip from "../../parts/tooltip";
import ToggleLinksInput from "../../parts/inputs/toggle-links-input";
import ProfileModal from "../../parts/modals/profile";
import AdminPassModal from "./admin-pass-modal";
import json2csv from "json2csv";
import AdminToggle from "./components/AdminToggle";

const PAGE_SIZE = 100;

function View(props, { locals }) {
  const { momentTZ, query } = locals;
  const usersList = locals.admin_allUsers;
  const usersOptions = [
    {
      text: "All Users",
      value: "all",
      href: `/actions/refresh?users=all&page=1`,
    },
    {
      text: "Admin Users",
      value: "admin",
      href: `/actions/refresh?users=admin&page=1`,
    },
    {
      text: "Ambassador Users",
      value: "ambassador",
      href: `/actions/refresh?users=ambassador&page=1`,
    },
  ];

  return (
    <main className="admin">
      <AdminToggle />

      <div className="Users-List">
        <div className="head">
          <ToggleLinksInput
            className="alt"
            name="users"
            options={usersOptions}
          />

          <form action="/admin/users" method="GET">
            <div className="search">
              <div className="columns">
                <div className="column" data-col="2/5">
                  <input
                    type="hidden"
                    name="users"
                    defaultValue={query.users}
                  />
                  <input
                    type="search"
                    className="text-input"
                    name="name"
                    placeholder="Name"
                    defaultValue={query.name}
                  />
                </div>
                <div className="column" data-col="2/5">
                  <input
                    type="search"
                    className="text-input"
                    name="email"
                    placeholder="E-mail"
                    defaultValue={query.email}
                  />
                </div>
                <div className="column" data-col="2/5">
                  <input
                    type="search"
                    className="text-input"
                    name="_id"
                    placeholder="User id"
                    defaultValue={query._id}
                  />
                </div>
                <div className="column" data-col="2/5">
                  <input
                    type="search"
                    className="text-input"
                    name="organizationId"
                    placeholder="Organization id"
                    defaultValue={query.organizationId}
                  />
                </div>
                <div className="column" data-col="2/5">
                  <button
                    data-button-type="outline"
                    className="button-input"
                    type="submit"
                  >
                    Search
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div className="users">
          <div className="labels">
            <div className="name">
              Showing {usersList.length} of {locals.admin_allUsersCount} Total
              Users
            </div>
            <div className="status">Status</div>
            <div className="date">Member Since</div>
            <div className="logged-in">Last Logged In</div>
          </div>

          {map(usersList, (user) => {
            return (
              <div className="user" key={user._id}>
                <div className="name">
                  {user.name + " (" + user.email + ")"}
                </div>
                <div className="status">{capitalize(user.type)}</div>
                <div className="date">
                  {momentTZ(user.registered).format("MMM DD YYYY")}
                </div>
                <div className="logged-in">
                  {locals.momentTZ(user.loggedIn).format("ll")}
                </div>
                <a
                  className="link"
                  href={`/actions/refresh?modal[type]=profile&user=` + user._id}
                />
                <div className="admin-pass">
                  <a
                    href={
                      `/actions/refresh?modal[type]=adminPass&user=` + user._id
                    }
                  >
                    <ToolTip id={user._id} body="Temporary password">
                      <img width="20" src="/img/icons/lock.webp"></img>
                    </ToolTip>
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </main>
  );
}

const Users = (app) => {
  app
    .use(set("heading", ["Admin", "Users"]))
    .get(
      "/users",
      async ({ api, req, res, locals, load, momentTZ, session }) => {
        const { query = {} } = req;
        const modal = get(query, "modal", {});

        defaults(query, {
          users: "all",
          page: 1,
        });
        await load("admin_allUsersCount", {
          page: query.page,
          pageSize: PAGE_SIZE,
          name: query.name,
          email: query.email,
          type: query.users,
          _id: query._id,
          organizationId: query.organizationId,
        });

        await load("admin_allUsers", {
          page: query.page,
          pageSize: PAGE_SIZE,
          name: query.name,
          email: query.email,
          type: query.users,
          _id: query._id,
          organizationId: query.organizationId,
        });

        if (modal.type === "profile") {
          const data = await load("admin_profileUser", { user: query.user });
          await load("stripeRecentEvents", {
            customerId: query.user,
          });
          if (data.subscription || data.membership) {
            const user = data.subscription?.feId || data.membership.coachId;
            await load("athlete", {
              user,
            });
          }
        }

        const stripePlans = await load("stripePlans");

        locals.modal = {
          profile: <ProfileModal stripePlans={stripePlans} />,
          adminPass: (
            <AdminPassModal
              allUsers={locals.admin_allUsers}
              user={query.user}
              api={api}
            />
          ),
        }[modal.type];

        locals.query = query;

        res.body = <View />;
      }
    )
    .get("/users/excel", async ({ req, res, locals, load, headers }) => {
      await load("admin_allUsers");
      const { query } = req;
      const { admin_allUsers } = locals;
      const fields = [
        "name",
        "type",
        "email",
        "birthday",
        "gender",
        "country",
        "registered",
      ];

      res.headers["Content-Disposition"] =
        "attachment; filename=" + "users.csv";
      res.body = await json2csv({ data: admin_allUsers, fields: fields });
    });
};

export default Users;
